import type { StepComponentRegistry } from "@onboardjs/react";
import { ConnectEmailStep } from "./ConnectEmailStep";
import { DomainDiscoveryStep } from "./DomainDiscoveryStep";
import { PersonProfileStep } from "./PersonProfileStep";
import { ReviewFirmStep } from "./ReviewFirmStep";

// OnboardJS step components ignore the StepComponentProps (payload/context)
// and instead use Convex queries directly for data access.
export const setupComponentRegistry: StepComponentRegistry = {
	"domain-discovery": DomainDiscoveryStep,
	"connect-email": ConnectEmailStep,
	"review-firm": ReviewFirmStep,
	"person-profile": PersonProfileStep,
};
